import { render, staticRenderFns } from "./ForeignSchoolsData.vue?vue&type=template&id=3c7d2eee"
import script from "./ForeignSchoolsData.vue?vue&type=script&lang=js"
export * from "./ForeignSchoolsData.vue?vue&type=script&lang=js"
import style0 from "./ForeignSchoolsData.vue?vue&type=style&index=0&id=3c7d2eee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports